import React from 'react';
import { Mail, Heart } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#2C2A29] text-[#FDFBF7] py-16 px-6 text-center" data-id="element-32">
      <div className="max-w-4xl mx-auto" data-id="element-33">
        <h2 className="text-3xl md:text-4xl mb-8 text-amber" data-id="element-34">The Kan Family</h2>

        <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-12 text-white/70" data-id="element-35">
          <div className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer" data-id="element-36">
            <Mail className="w-5 h-5" data-id="element-37" />
            <span data-id="element-38">kanfamilyreunion@gmail.com</span>
          </div>
        </div>

        <div className="w-full h-px bg-white/10 mb-8" data-id="element-39" />

        <div className="flex items-center justify-center gap-2 text-white/50 text-sm" data-id="element-40">
          <span data-id="element-41">Made with</span>
          <Heart className="w-4 h-4 text-terracotta fill-terracotta" data-id="element-42" />
          <span data-id="element-43">for the family. See you in SF!</span>
        </div>
      </div>
    </footer>;
}